import React, { useState, useCallback } from 'react';
import ConfirmDialog from './ConfirmDialog';

/**
 * Hook que substitui window.confirm por um ConfirmDialog estilizado.
 *
 * Uso:
 *   const [confirmEl, confirm] = useConfirm();
 *   ...
 *   if (!await confirm({ title, message, confirmLabel, cancelLabel, confirmVariant })) return;
 *   ...
 *   return (<>{confirmEl} ...resto do componente... </>);
 *
 * `confirm` aceita uma string (só mensagem) ou um objeto de opções e devolve
 * uma Promise<boolean> (true = confirmou, false = cancelou/fechou).
 */
export default function useConfirm() {
  const [state, setState] = useState(null); // { opts, resolve }

  const confirm = useCallback(
    (opts) =>
      new Promise((resolve) => {
        setState({ opts: typeof opts === 'string' ? { message: opts } : (opts || {}), resolve });
      }),
    []
  );

  const finalizar = (resultado) => {
    setState((atual) => {
      if (atual?.resolve) atual.resolve(resultado);
      return null;
    });
  };

  const confirmEl = (
    <ConfirmDialog
      open={state !== null}
      title={state?.opts.title}
      message={state?.opts.message}
      confirmLabel={state?.opts.confirmLabel || 'Confirmar'}
      cancelLabel={state?.opts.cancelLabel || 'Cancelar'}
      confirmVariant={state?.opts.confirmVariant || 'primary'}
      onConfirm={() => finalizar(true)}
      onCancel={() => finalizar(false)}
      onClose={() => finalizar(false)}
    />
  );

  return [confirmEl, confirm];
}
